import React, { useState, useEffect, useLayoutEffect } from "react";
import "../css/InputData.css";
import {
  formatField,
  reformatField,
  convertToNative,
  checkFormat,
} from "../js/format";
import { inputOnEnter, isValidDateString } from "../js/utils";

export default function InputData(props) {
  const [value, setValue] = useState(null);
  const [formattedValue, setFormattedValue] = useState(null);
  const [isTyping, setIsTyping] = useState(false);

  let inputRef = React.useRef();
  const cursorPosRef = React.useRef(null);

  const getInputSize = () => {
    const sizeClass = {
      0: "input-full",
      1: "input-small",
      2: "input-medium",
      3: "input-large",
      4: "input-super-small",
      5: "input-super-small-2",
      6: "input-full-flex",
      7: "input-small-3",
      8: "input-small-4",
    };
    return sizeClass[props.size] || "";
  };

  useLayoutEffect(() => {
    if (cursorPosRef.current !== null && inputRef.current) {
      inputRef.current.setSelectionRange(
        cursorPosRef.current,
        cursorPosRef.current,
      );
      cursorPosRef.current = null;
    }
  }, [formattedValue]);

  useEffect(() => {
    if (props.input != null && !isTyping) {
      setValue(props.input.toString());
      setFormattedValue(reformatField(props.input.toString(), props.type));
    }
  }, [props.input, isTyping]);

  return (
    <div
      className={`input-data ${getInputSize()} ${
        props.extra ? props.extra : ""
      } ${props.error ? "input-error" : ""} ${props.bkg ? "marked-bkg" : ""} ${
        props.inactive ? "inactive-bkg" : ""
      } ${props.forceCenter ? "content-center" : ""} ${props.customStyle || ""}`}
    >
      <input
        ref={inputRef}
        id={props.id}
        name={props.name}
        className={props.password ? "input-data-password-mask" : undefined}
        tabIndex={props.inactive ? -1 : props.tabIndex}
        type={props.password ? "text" : props.type ? props.type : "text"}
        autoComplete={props.password ? "off" : props.autoComplete}
        data-lpignore={props.password ? "true" : undefined}
        disabled={props.inactive}
        maxLength={props.maxLength}
        max={props.type === "date" ? (props.max ?? "9999-12-31") : undefined}
        onChange={(e) => {
          setIsTyping(true);

          cursorPosRef.current = inputRef.current?.selectionStart ?? null;

          const fValue = formatField(
            inputRef.current,
            e.target.value,
            props.type,
            props.dontForceUppercase,
          );
          setFormattedValue(fValue);

          const nValue = convertToNative(
            reformatField(fValue, props.type),
            props.type,
          );
          setValue(nValue);

          props.onChange(nValue);
        }}
        value={formattedValue ?? ""}
        onBlur={(e) => {
          setIsTyping(false);

          // Fechas inexistentes (p. ej. 31/09) o fuera de rango: se vacían
          if (
            props.type === "date" &&
            (e.target.validity.badInput ||
              (e.target.value !== "" && !isValidDateString(e.target.value)))
          ) {
            e.target.value = "";
            setFormattedValue("");
            setValue("");
            props.onChange("");
            if (props.onBlur) props.onBlur("");
            return;
          }

          const rValue = reformatField(e.target.value, props.type);
          setFormattedValue(rValue);

          const nValue = convertToNative(rValue, props.type);
          setValue(nValue);

          if (props.onMalformed) {
            if (!checkFormat(rValue, props.type)) {
              props.onMalformed();
            }
          }

          if (props.onBlur) {
            props.onBlur(nValue);
          }
        }}
        onKeyUp={(e) => {
          if (e.key === "Enter") {
            if (props.onEnter) {
              props.onEnter();
            } else {
              inputOnEnter(e);
            }
          }
        }}
        onFocus={(e) => {
          if (props.onFocus) {
            props.onFocus();
          }
        }}
      ></input>
      {!props.password && props.icon && (
        <button
          onClick={() => {
            props.onClick();
          }}
        >
          <img src={props.icon} loading="lazy" alt="Icon" />
        </button>
      )}
    </div>
  );
}
